import $ from 'jquery';
import AccountService from '../_shared/account-service';

/**
 * @desc Load match day card widgets template
 *  */

export default class MatchDayCardWidgets {
  /**
 * @param {string} container
 */
  constructor({
    container = '.match-day-card',
  } = {}) {
    this.$window = $(window);
    this.$container = $(container);
    this.videoPlayerId = 'match-day-card-player';

    this.reloadUrl = this.$container.data('reload-url');

    this.$matchInfo = this.$container.find('[data-match-info]'); // matchInfo container
    this.$matchInfoLabel = this.$container.find('[data-match-info-label]'); // ko time or current time
    this.$matchInfoCountdown = this.$container.find('[data-match-info-countdown]'); // countdown
    this.$matchInfoScores = this.$container.find('[data-match-info-scores]'); // scores
    this.$matchInfoScoresHome = this.$matchInfoScores.find('[data-match-info-scores-home]'); // home team score
    this.$matchInfoScoresAway = this.$matchInfoScores.find('[data-match-info-scores-away]'); // away team score
    this.$matchInfoVideo = this.$container.find('[data-match-info-video]'); // video
    this.$matchInfoLink = this.$container.find('[data-match-info-link]'); // link
    this.$matchInfoStatus = this.$container.find('[data-match-status]'); // link
    this.matchTimezone = this.$container.data('match-timezone');
    this.cityPlusVideoId = this.$container.data('city-plus-video-id');
    this.videoPlayer = document.querySelector('#match-day-card-player');

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (this.$container.length) {
      this.premiumVideo(this.cityPlusVideoId);
      setInterval(() => {
        this.fetchMatchData();
      }, 60000);
    }
  }

  fetchMatchData() {
    fetch(this.reloadUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.isInCountdownMode) {
          this.matchStatus = 'pre-match';

          // this.$matchInfoStatus.text(`KO ${data.matchTime} ${this.matchTimezone}`);

          this.$matchInfoScores.addClass('hidden');
          this.$matchInfoCountdown.addClass('show');
          this.$matchInfo.addClass('--with-countdown');
        } else if (data.isLive || data.isHalfTime) {
          const text = data.isHalfTime ? 'Half-time' : data.matchTime;
          this.matchStatus = 'live';

          this.$matchInfoStatus.text(text);

          this.$matchInfoScores.addClass('show');
          this.$matchInfoCountdown.addClass('hidden');

          this.$matchInfo.removeClass('--with-countdown');
        } else if (data.isPostMatch) {
          this.matchStatus = 'full-time';

          this.$matchInfoStatus.text('Full-time');
          this.$matchInfoLink.text('full-time analysis');

          this.$matchInfoScores.addClass('--finished');
          this.$matchInfo.removeClass('--with-countdown');
        }

        if (this.matchStatus === 'live' || this.matchStatus === 'full-time') {
          this.$matchInfoScoresHome.text(data.homeTeamScore);
          this.$matchInfoScoresAway.text(data.awayTeamScore);
        }

        if (data.cityPlusVideoId) {
          this.premiumVideo(data.cityPlusVideoId);
        }
      });
  }

  async premiumVideo(videoId) {
    if (!videoId) {
      return;
    }

    try {
      await AccountService.isAuthenticated();

      let hasSubscription;
      const userData = await AccountService.getUserData();
      if (userData) {
        hasSubscription = await AccountService.isPremiumUser(userData.id);
      }

      if (hasSubscription) {
        try {
          window.videojs.getPlayer(this.videoPlayerId).ready(function onPlayerReady() {
            const player = this;

            player.catalog.getVideo(videoId, (error, video) => {
              if (error) {
                console.error('An error occured white getting video: ', error);
                return;
              }

              player.catalog.load(video);
            });
          });
        } catch (e) {
          console.error('Error:', e.error, 'Details:', e.details);
        }
      } else {
        console.warn('User doesn\'t have a subscription!');
      }
    } catch (e) {
      console.error(`An error occurred during validation of user subscription: ${e}`);
    }
  }
}
